module.exports = __webpack_public_path__ + "img/ChatCircleDots.56a30b5b.svg";